<template>
  <div class="process-view" v-loading = formLoading element-loading-text="正在加载，请稍候">
    <div class="main">
      <div class="form" ref="formStyle" :style="{height: formHeight,overflow: nodeTabEnable?'hidden':'auto'}">
        <!-- 分组导航栏-->
        <div v-if="showGroupNav" class="process-group-nav">
          <el-tabs tab-position="left" @tab-click="navToGroup" value="''" v-if="nodeTabEnable">
            <el-tab-pane v-for="item in getCurrentgroupComponent(nodeTab.activeName)" :key="item.id" :label="item.name" @click.native="test">
              <span slot="label" :title="item.name">{{item.name && item.name.length > 16 ? item.name.slice(0,15)+'...' : item.name}}</span>
            </el-tab-pane>
          </el-tabs>
          <el-tabs v-else tab-position="left" @tab-click="navToGroup" value="''">
            <el-tab-pane v-for="item in groupComponent" :key="item.id" :label="item.name" @click.native="test"></el-tab-pane>
          </el-tabs>
        </div>
        <!-- 表单-->
        <div :class="[showGroupNav&&'process-group-nav-form', nodeTabEnable&&'box1']">
         <!-- 节点tab展示 -->
          <div v-if="nodeTabEnable" :class="{'box1':nodeTabEnable}" >
            <el-tabs type="card" class="node-tab" v-model="nodeTab.activeName">
              <el-tab-pane v-for="item in getComponent" :key="item.id" :label="item.name" :name="item.id">
                <span slot="label" :title="item.name">{{item.name}}</span>
                <rc-form
                v-if="item"
                v-show="hiddenForm(item)"
                ref="form"
                :value="dataService.data"
                :component="item"
                :disable="comeFrom !== 'instanceListEdit'"
                :title="'process'"
                :parentPath="[item.archive.columnId]"
                :nodeTabEnable="nodeTabEnable"/>
              </el-tab-pane>
            </el-tabs>
          </div>
          <!-- 各个节点-->
          <div v-else v-for="item in getComponent" :key="item.id">
            <div>
              <rc-form
                v-if="item"
                v-show="hiddenForm(item)"
                ref="form"
                :value="dataService.data"
                :component="item"
                :disable="comeFrom !== 'instanceListEdit'"
                :title="'process'"
                :parentPath="[item.archive.columnId]"/>
            </div>
          </div>
        </div>
      </div>
      <div class="candidate-button" v-if="isFromDoingTasks">
        <div class="button">
          <el-row>
            <el-button class="read-button" @click="readTask">
              <i class="el-icon-loading" v-if="isReading"></i>已阅
            </el-button>
          </el-row>
        </div>
      </div>
      <div class="candidate-button" v-if="comeFrom === 'instanceListEdit'">
        <div class="button">
          <el-row>
            <el-button type="primary" :loading="instanceEditLoading" @click="instanceEdiSave" :tabindex="30000">保存</el-button>
          </el-row>
        </div>
      </div>
    </div>
    <dialog-process-runtime v-if="processPublicDialog.visible" :data="processPublicDialog" :variables="dataService.data"></dialog-process-runtime>
  </div>
</template>

<script>
import sdk from 'redcatSdk'
import RcForm from '../../form/runtime/components/rc-form'
import {FormComponent} from '../../../store/form/component'
import DataService from '../../../store/form-runtime/dataService.js'
import CodeService, { EventBus } from '@/store/form-runtime/codeService'
import {calculationMixin, interactionMixin} from '../../form/runtime/components/mixins'
import { processNavMixin, processNodeInteraction } from './mixin'
import CookieOperation from '@/plugins/cookie'

const dataService = new DataService()
export default {
  name: 'process-view',
  provide () {
    return {
      dataService,
      eventBus: this.eventBus,
      initState: {},
      redcatApp: () => { return {} }, // todo: 已办查看暂时不执行js方法, 后续需要要加上
      formVm: this
    }
  },
  props: ['dialogInstanceId', 'currentstateNodeId', 'isFromDoingTasks', 'nodeId', 'comeFrom'],
  mixins: [calculationMixin, interactionMixin, processNavMixin, processNodeInteraction],
  data () {
    return {
      eventBus: new EventBus(),
      initStateObj: {state: false, type: 'process'},
      nodes: [],
      processComponent: {},
      instanceId: this.$route.params.instanceId || this.dialogInstanceId,
      allData: [],
      // 历史节点
      historyNodeIds: [],
      currentNodeId: '',
      dataService,
      processPublicDialog: {
        visible: false,
        title: 'title',
        width: '30%',
        // 是否可以通过点击 modal 关闭弹窗
        closeWithClick: false,
        // 是否可以通过 esc键 关闭弹窗
        closeWithEsc: true
      },
      isReading: false,
      nodeTabEnable: false,
      nodeTab: {
        activeName: ''
      },
      // 是否开启了已办查看限制（为晟融租户专用）
      checkRestrict: false,
      // 历史节点处理人信息
      historyHandler: [],
      instanceEditLoading: false,
      formLoading: false
    }
  },
  components: {
    RcForm,
    DialogProcessRuntime: () => {
      return Promise.resolve(sdk.components.DialogProcessRuntime)
    }
  },
  async created () {
    let tenantId = CookieOperation.get('tenantId')
    if (tenantId === '16DB9E8F-4B50-003D-9ED7-32C247B72173') {
      this.formLoading = true
    }
    this._provided.initState = this.initStateObj
    this._provided.initState.historyNodeIds = null
    this._provided.initState.currentNodeId = null
    await this.getHistoryHandler()
    await this.loadForm()
    await this.buildData()
    this.$nextTick(() => {
      this.initStateObj.state = true
    })
    const customProcessDialog = {
      openProcessPublicDialog: (params) => {
        this.$_.assign(this.processPublicDialog, params)
      }
    }
    const codeService = new CodeService({eventBus: this.eventBus, process: {define: this.processComponent, dataService: this.dataService, currentNode: this.currentNode, customProcessDialog: customProcessDialog, withoutHandleDataService: this.withoutHandleDataService}, el: this})
    codeService.load()
    if (this.nodeTabEnable) {
      // 找到第一个不被隐藏的节点
      let component = this.getComponent.find(m => !m.properties.hidden)
      this.nodeTab.activeName = component ? component.id : ''
    }
    this.$nextTick(() => {
      this.formLoading = false
    })
  },
  methods: {
    loadForm () {
      let request = this.$axios.get(`/process-api/runtime/processView/${this.instanceId}`)
      return request.then(res => {
        this.checkRestrict = res.data.definition.process.attribute.checkRestrict
        this.nodes = res.data.definition.process.nodes.filter(m => m.type === 'userTask')
        this.nodeTabEnable = res.data.definition.nodeTabEnable
        this.historyNodeIds = res.data.historyNode
        this.groupNavDefinition = res.data.definition.groupNav
        let component = FormComponent.load(res.data.component)
        if (res.data.data) {
          this.dataService.data = res.data.data
        }
        this.processComponent = component
        this.dataService.schema = res.data.schema
        // 处理节点交互
        if (res.data.definition.process.attribute.nodeInteractions) {
          this.handleProcessNodeInteraction(res.data.definition.process.attribute.nodeInteractions)
        }
        this.initInteraction()
        // 分组导航
        this.$nextTick(() => {
          this.getProcessGroupNav()
        })
      })
    },
    buildData () {
      if (Object.keys(this.dataService.data).length <= 0) {
        let data = this.dataService.buildModel(this.processComponent.archive.tableId)
        this.dataService.data = data
      }
    },
    readTask () {
      if (this.isReading) {
        return null
      }
      this.isReading = true
      this.$axios.get(`/process-api/runtime/readTask/${this.instanceId}`).then(res => {
        this.$emit('closeDialog', 'process')
        this.isReading = false
      }).catch(() => {
        this.isReading = false
      })
    },
    // 获取历史节点处理人
    getHistoryHandler () {
      return this.$axios.get(`/process-api/runtime/dealRecord?taskId=${this.instanceId}`).then(res => {
        let nodes = res.data.reverse() || []
        // 找到已处理的节点中当前用户处理的最后一个节点id
        let userId = sessionStorage.getItem('userId') || localStorage.getItem('userId')
        let index = nodes.findIndex(n => n.userId === userId)
        if (index !== -1) this.historyHandler = nodes.splice(index)
      })
    },
    // 流程实例（新）管理流程实例，编辑后保存
    instanceEdiSave () {
      this.instanceEditLoading = true
      this.$axios.post(`/process-api/runtime/updateProcessData/${this.dialogInstanceId}`, this.dataService.data).then(() => {
        this.instanceEditLoading = false
        this.$message.success('修改成功！')
        this.$emit('closeDialog', 'process-instance-edit')
      }).catch(() => {
        this.instanceEditLoading = false
      })
    }
  },
  computed: {
    getComponent () {
      let userHandleLastNodeId = '' // 已处理的节点中当前用户处理的最后一个节点id（只针对晟融的已完成流程的已办查看）
      let components = []
      if (this.currentstateNodeId) {
        let node = this.nodes.find(n => n.id === this.currentstateNodeId)
        if (node) {
          let component = this.processComponent.children.find(n => n.id === node.formId)
          component.history = true
          components.push(component)
        }
      } else {
        this.historyNodeIds.forEach(m => {
          let node = this.nodes.find(n => n.id === m)
          let needAdd = true
          if (node) {
            // 如果是开启了 已办查看限制 只能查看当前用户处理的最后一个节点之前的节点信息
            if (this.checkRestrict) {
              if (this.historyHandler.length) {
                userHandleLastNodeId = this.historyHandler[0].nodeId
              }
              if (this.historyHandler.length && !this.historyHandler.find(h => h.nodeId === node.id) && m !== 'node-id') needAdd = false
            }
            if (needAdd) {
              let component = this.processComponent.children.find(n => n.id === node.formId)
              component.history = true
              components.push(component)
            }
          }
        })
      }
      components = this.updateFormNodeInteractions(components, this.checkRestrict ? userHandleLastNodeId : this.nodeId)
      return components
    },
    formHeight () {
      let height = 32
      if (this.isFromDoingTasks) {
        height = 0
      }
      return `calc(100% - ${height}px)`
    }
  }
}
</script>

<style lang="scss">
  .process-view {
    width: 100%;
    height: 100%;
    background: #fff;
    box-shadow: 4px 4px 4px rgba(174, 222, 251, 0.1);
    .el-loading-mask {
      .el-loading-spinner {
        top:40%;
        .el-loading-text {
        color: #333333;
      }
      }
    }
    > div.main {
      width: 100%;
      height: 100%;
      padding: 20px 20px 30px 20px;
      > div.form {
        width: 100%;
      }
      .form {
        position: relative;
        margin-bottom: 10px;
        .box1 {
          height: 100%;
        }
        .node-tab {
          height: 100%;
          .el-tabs__content {
            overflow: auto;
            height: calc(100% - 44px);
          }
          .el-tabs__item  {
            height: 28px;
            line-height: 28px;
            width: 112px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
          }
        }
        .process-group-nav{
          position: fixed;
          width: 124px;
          height: calc(100% - 200px);
          overflow-y: scroll;
          .el-tabs__header.is-left{
            width: 114px;
            .el-tabs__item{
              height: 50px;
              line-height: 15px;
              padding-left: 0;
              white-space: pre-line;
              padding-top: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .el-tabs__content{
            display: none;
          }
          @media (min-width: 1366px){
            width: 160px;
            .el-tabs__header.is-left{
              width: 150px;
            }
          }
        }
        .process-group-nav-form{
          margin-left: 124px;
          @media (min-width: 1366px){
            margin-left: 160px;
          }
        }
      }
      .candidate-button{
        padding-left: 24px;
        .button {
          .el-row {
            text-align: center;
            .el-button--mini {
              padding: 5px 9px;
              &.read-button{
                border: 1px solid #52ACF1;
                color: #52ACF1;
              }
            }
          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/process/runtime/process-view.vue